import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

class CookieNoticeComponent extends Component {
  init() {
    this.category = this.element.getAttribute('data-category')
    this.buttonAccept = this.element.querySelector('.button--accept')
    this.buttonConfigure = this.element.querySelector('.button--configure')

    if (!this.category) {
      return
    }

    this.buttonAccept?.addEventListener('click', () => this.accept())
    this.buttonConfigure?.addEventListener('click', () => this.configure())
  }

  accept() {
    window.CookieFirst?.acceptCategory(this.category)
  }

  configure() {
    window.CookieFirst?.openPanel('settings')
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'cookie-notice', CookieNoticeComponent))
